import { Button } from "react-admin";
import { ButtonGroup } from "@mui/material";
import TableChartIcon from "@mui/icons-material/TableChart";
import AppsIcon from "@mui/icons-material/Apps";
import { useListView } from "./useListView";

export const ListViewButton = ({ disabled }: { disabled?: boolean }) => {
  const [view, setView] = useListView();

  return (
    <ButtonGroup key="view-selector-tool-menu" disabled={disabled}>
      <Button color={view === "table" ? "inherit" : "primary"} onClick={(): void => setView("table")} label="Table">
        <TableChartIcon />
      </Button>
      <Button color={view === "grid" ? "inherit" : "primary"} onClick={(): void => setView("grid")} label="Grid">
        <AppsIcon />
      </Button>
    </ButtonGroup>
  );
};
